import { Component, OnDestroy } from '@angular/core'
import { Subject } from 'rxjs'
import { map, startWith, switchMap } from 'rxjs/operators'
import { RankingsService } from '../rankings.service'
import { AdComponentInputs } from '../../shared/ads/ad/ad-component.interface'
import {
  AD_SKIN_SIZE,
  AD_LEADERBOARD_LARGE_FLEX_SIZE,
  AD_LEADERBOARD_SMALL_SIZE,
  AD_RECTANGLE_LARGE_SIZE,
  AD_ADHESION_SIZE
} from 'src/app/shared/ads/ads.utility'
import { AdConfig } from 'src/app/shared/ads/advertising-service/ad-config'
import { environment } from 'src/environments/environment'
import { IRanking } from '../interfaces/ranking.interface'
import { RANKINGS_LIST, RankingsAnalyticsService } from '../rankings-analytics.service'
import { FloResponse } from '@flocasts/flosports30-types/dist/flo-rest-api/response'

@Component({
  selector: 'flo-rankings',
  templateUrl: './rankings.component.html',
  styleUrls: ['./rankings.component.scss']
})
export class RankingsComponent implements OnDestroy {
  constructor(private readonly rankingsService: RankingsService, private readonly analytics: RankingsAnalyticsService) {
    this.analytics.sendListPageCall(RANKINGS_LIST)
    this.analytics.setPageMeta()
  }

  private readonly ngOnDestroy$ = new Subject<void>()
  private limitNumberSource = new Subject<number>()

  public ranking$ = this.limitNumberSource.pipe(
    startWith(10),
    switchMap(limit => this.rankingsService.getRankings(limit)),
    map((rankings: FloResponse<ReadonlyArray<IRanking>, { page: number; limit: number; total: number }>) => {
      return {
        data: rankings.data,
        meta: rankings.meta,
        showButton: !(rankings.meta.limit >= rankings.meta.total || rankings.meta.page === 0)
      }
    })
  )

  public setResultsLimitNumber(meta: { page: number; limit: number; total: number }): void {
    this.limitNumberSource.next(meta.limit + 10)
  }

  trackByRanking(index: number, item: IRanking) {
    return item.id
  }

  public ngOnDestroy(): void {
    this.analytics.removePageMeta()
    this.ngOnDestroy$.next()
    this.ngOnDestroy$.complete()
  }

  // Ads for rankings-list page
  public readonly AdComponent = import('../../shared/ads/ad/ad.component').then(m => m.AdComponent)

  public adSkin: AdComponentInputs = {
    config: {
      adConfig: AdConfig('rankings/list/atf', AD_SKIN_SIZE, 'ad-rankings-skin')
    }
  }
  public adLeaderboardLarge: AdComponentInputs = {
    config: {
      adConfig: AdConfig('rankings/list/728x90_flex', AD_LEADERBOARD_LARGE_FLEX_SIZE, 'ad-rankings-leaderboard'),
      additionalOpts: { deferClick: environment.advertising.preventClickTimeout, maxRefreshTime: 60000 }
    }
  }

  public adLeaderboardSmall: AdComponentInputs = {
    config: {
      adConfig: AdConfig('rankings/list/728x90_flex', AD_LEADERBOARD_SMALL_SIZE, 'ad-rankings-leaderboard-tablet'),
      additionalOpts: { maxRefreshTime: 60000 }
    }
  }

  public adSidebarRectangle: AdComponentInputs = {
    config: {
      adConfig: AdConfig('rankings/list/300x250_1', AD_RECTANGLE_LARGE_SIZE, 'ad-rankings-sidebar'),
      additionalOpts: { maxRefreshTime: 60000 }
    }
  }

  public adAdhesion: AdComponentInputs = {
    config: {
      adConfig: AdConfig('rankings/list/adhesion', AD_ADHESION_SIZE, 'ad-rankings-adhesion'),
      additionalOpts: { maxRefreshTime: 30000 }
    }
  }
}
